<script>
import {resolveBreadcrumbItems} from "@/mixins/resolveBreadcrumbItems";

export default {
  name: "Breadcrumbs",
  props: ["items"],
  mixins: [resolveBreadcrumbItems],
  computed: {
    mappedItems() {
      return this.breadcrumbItems.map(item => {
        return {
          text: item,
        }
      })
    }
  }
}
</script>

<template>
  <v-breadcrumbs class="pl-0" :items="mappedItems">
    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<style scoped>

</style>